// import React from "react";
import {
  Input,
  Radio,
  Button,
  Checkbox,
  Alert,
  Row,
  Col,
  Select,
  message,
  Spin,
} from "antd";
import styles from "./index.module.scss";
import classNames from "classnames";
import React, { useMemo, useState, useEffect } from "react";
import DetailTitle from "@/components/DetailTitle";

import {
  licenseType,
  // createResource,
  getDetail,
  updateResource,
  getTagSearch,
  getAuthorSearch,
} from "@/apis/discover";
import { tags_list } from "@/apis/tag";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import UploadManage from "./components/uploadManage";
import NewTag from "./components/NewTag";
import Coverage from "./components/coverage";
import FileUpload from "./components/fileUpload";
import intl from "react-intl-universal";
import { useUploadQueue } from "@/contexts/uploadQueueContext";
import { uploadHowToUseFile } from "@/utils/uploadHowToUseFile";
const { TextArea } = Input;
// const [messageApi, contextHolder] = message.useMessage();

let typeList = [],
  suffixList = [];

const Share = () => {
  let data = localStorage.getItem("jsonTypeData");
  if (data) {
    let res = JSON.parse(data);
    typeList = res.typeList;
    suffixList = res.suffixList;
  }
  const { userInfo } = useSelector((state) => state.user);
  const { tasks: uploadTasks } = useUploadQueue();
  const token = useMemo(() => userInfo?.token, [userInfo]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const resourceUuid = searchParams.get("id");
  const [isReload, setIsReload] = useState(false);
  const [title, setTitle] = useState("");
  const [firstType, setFirstType] = useState("OpenData");
  const [secondType, setSecondType] = useState("");
  const [typeTitle, setTypeTitle] = useState("");
  const [resourceType, setResourceType] = useState("");
  const [dataSource, setDataSource] = useState("");
  const [sampleType, setSampleType] = useState("");
  const [isShow_api, setIsShow_api] = useState(false);
  const [liceseType, setLiceseType] = useState("0");
  const [tagUuids, setTagUuids] = useState([]);
  const [description, setDescription] = useState("");
  const [mapObj, setMapObj] = useState({});
  const [isComputable, setIsComputable] = useState(false);
  const [isDownloadable, setIsDownloadable] = useState(true);
  const [isPublic, setIsPublic] = useState(true);
  const [authors, setAuthors] = useState([]);
  const [tagSearch, setTagsSearch] = useState([]);
  const [authorsSearch, setAuthorsSearch] = useState([]);
  const [relatedResources, setrelatedResources] = useState([]);
  const [serviceApi, setServiceApi] = useState("");
  // how to cite
  const [licenseList, setLicenseList] = useState([]);
  const [dis, setDis] = useState(false);

  const [howToCite, setHowToCite] = useState("");
  const [licenseStatement, setLicenseStatement] = useState("");
  const [licenseUrl, setLicenseUrl] = useState("");
  const [imgPath, setImgPath] = useState("");

  const [configuration, setConfiguration] = useState("");
  const [howToUseFileUuid, setHowToUseFileUuid] = useState("");
  const [howToUseUploading, setHowToUseUploading] = useState(false);

  // 编辑时需要回显的文件列表
  const [useFile_de, setUseFile_de] = useState([]);
  const [fileList_de, setFileList_de] = useState([]);
  const [quikTagList, setQuikTagList] = useState([])

  useEffect(() => {
    getTagSearch().then((res) => {
      const data = res.data.map((item) => {
        return { label: item.tag, value: item.tag };
      });
      setTagsSearch(data);
    });
    getAuthorSearch().then((res) => {
      const data = res.data.map((item) => {
        return { label: item.author, value: item.author };
      });
      setAuthorsSearch(data);
    });
  }, []);


  useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    const {
      firstType,
      secondType,
      resourceType,
      typeTitle,
      liceseType,
      isShow_api,
    } = params;
    setFirstType(firstType);
    setSecondType(secondType);
    setTypeTitle(typeTitle);
    setLiceseType(liceseType);
    setIsShow_api(isShow_api);
    setResourceType(resourceType);
  }, [window.location.search]);
  // 获取二级单选框
  const secondList = useMemo(() => {
    if (typeList) {
      return (
        typeList.filter((item) => item.value === firstType)[0]?.children || []
      );
    }
  }, [firstType]);

  // 根据secondType 获取类型下拉菜单
  const selectOption = useMemo(() => {
    // 证书类型
    if (secondType === "OpenCodes") {
      setLiceseType("1");
    } else {
      setLiceseType("0");
    }
    if (secondType) {
      tags_list({
        secondType: secondType,
        pageSize: 20,
        currentPage: 1,
      }).then(res => {
        setQuikTagList(res.data.records.map(item => { return { label: item.tag, value: item.tag } }))
      })
      const arr1 =
        typeList.filter((item) => item.value === firstType)[0]?.children || [];
      const arr2 = arr1.filter((item) => item.value === secondType);
      if (arr2.length > 0) {
        const title = arr2[0].title;
        const str = title.replace(/\s/g, "_");
        setTypeTitle(title);
        setIsShow_api(arr2[0].isShow_api);
        return suffixList[str];
      } else {
        setIsShow_api(false);
        return [];
      }
    } else {
      setIsShow_api(false);
      return [];
    }
  }, [firstType, secondType]);
  // 获取license 下拉菜单
  const getLicenseList = () => {
    licenseType({
      licenseType: liceseType,
    })
      .then((res) => {
        setLicenseList([
          ...res.data,
          {
            licenseName: "other",
            licenseUrl: "other",
            imgPath: "",
            statement: "",
          },
        ]);
      })
      .catch((err) => { });
  };

  // 编辑时获取资源详情信息
  const getDetailInfo = () => {
    getDetail({
      resourceUuid: resourceUuid,
    })
      .then((res) => {
        const result = res.data;
        setTitle(result.title);
        setFirstType(result.firstType);
        setSecondType(result.secondType);
        setResourceType(result.resourceType?.typeName);

        setDataSource(result.dataSource);
        setSampleType(result.sampleType);

        setTagUuids(result.tags.map((item) => item.tag));
        setDescription(result.description);
        setServiceApi(result.serviceApi);
        setMapObj({
          startDate: result.startDate,
          endDate: result.endDate,
          longitude: result.longitude,
          latitude: result.latitude,
          areaName: result.areaName,
        });
        setIsComputable(result.isComputable);
        setIsDownloadable(result.isDownloadable);
        setIsPublic(result.isPublic);
        setAuthors(result.authors.map((item) => item.author));
        setrelatedResources(
          result.relatedResources ? result.relatedResources.split(",") : []
        );
        setHowToCite(result.howToCite || window.location.href);
        setLicenseStatement(result.license.statement);
        setLicenseUrl(result.license.licenseUrl);
        setImgPath(result.license.imgPath);
        setUseFile_de(result.howToUse ? [result.howToUse] : []);
        setHowToUseFileUuid(result.howToUse?.fileUuid || "");
        setFileList_de(result.files || []);
        setConfiguration(result.configuration);
        if (result?.license?.licenseUrl) {
          setDis(true);
        } else {
          setDis(false);
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {
    getLicenseList();
  }, [liceseType, token]);

  useEffect(() => {
    if (resourceUuid) {
      getDetailInfo();
      setIsReload(true);
    } else {
      if (isReload) {
        window.location.reload();
      }
    }
  }, [resourceUuid]);

  // 选择许可
  const selectLicense = (val) => {
    if (val !== "other") {
      const selected = licenseList.find((item) => item.licenseUrl === val);
      setLicenseStatement(selected?.statement || "");
      setImgPath(selected.imgPath);
      setLicenseUrl(val);
      setDis(true);
    } else {
      setImgPath("");
      setLicenseStatement("");
      setLicenseUrl("");
      setDis(false);
    }
  };

  // 同意协议
  const changeCheck = (e, set) => {
    set(e.target.checked);
  };

  const handleHowToUseUpload = async ({
    file,
    onProgress,
    onSuccess,
    onError,
  }) => {
    setHowToUseUploading(true);
    try {
      onProgress?.({ percent: 1 }, file);
      const fileUuid = await uploadHowToUseFile(file, secondType);
      const fileNameParts = file.name.split(".");
      setHowToUseFileUuid(fileUuid);
      setUseFile_de([
        {
          fileUuid,
          fileName: file.name,
          fileFormat: fileNameParts.length > 1 ? fileNameParts.pop() : "",
          fileSize: file.size,
        },
      ]);
      onProgress?.({ percent: 100 }, file);
      onSuccess?.({ code: 200, fileUuid }, file);
      message.success("文件上传成功");
    } catch (error) {
      onError?.(error);
      message.error(error?.message || "File upload failed");
    } finally {
      setHowToUseUploading(false);
    }
  };

  const updateHowToUseFileList = (files) => {
    setUseFile_de(files);
    if (!files.length) {
      setHowToUseFileUuid("");
    }
  };
  const aLink = (
    <span>
      {intl.get("Update successfully")}{" "}
      <a target="_blank" href="http://10.101.240.20:7777/developCenter">
        {intl.get("Access to OGE develop center")}
      </a>
    </span>
  );
  // 更新
  const update = (params) => {
    const fileUuids = Array.from(
      new Set([
        ...fileList_de.map((item) => item.fileUuid).filter(Boolean),
        ...uploadTasks
          .filter(
            (item) => item.resourceUuid === resourceUuid && item.status === "done"
          )
          .map((item) => item.fileUuid)
          .filter(Boolean),
      ])
    );
    updateResource({
      resourceUuid: resourceUuid,
      fileUuids: fileUuids,
      relatedResources: relatedResources.join(","),
      howToUseFileUuid: howToUseFileUuid,
      ...mapObj,
      ...params,
    })
      .then((res) => {
        setLoading(false);
        if (resourceType !== "Docker Image Tarball") {
          message.success(intl.get("Update successfully"));
        } else {
          message.open({
            type: "success",
            content: aLink,
            duration: 5,
          });
        }
        if (params.isAudit) {
          goMayShare(1000);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const goMayShare = (time) => {
    setTimeout(() => {
      navigate(`/discover/my-share`);
    }, time);
  };

  // 提交表单
  const submitForm = (status) => {
    const pendingUploadCount = uploadTasks.filter(
      (item) =>
        item.resourceUuid === resourceUuid &&
        ["queued", "hashing", "uploading"].includes(item.status)
    ).length;
    if (pendingUploadCount > 0) {
      message.warning("文件仍在后台上传，请等待上传完成后再保存");
      return;
    }
    if (howToUseUploading) {
      message.warning("“如何使用”文件仍在上传，请等待上传完成后再保存");
      return;
    }

    setLoading(true);
    const params = {
      firstType: firstType,
      secondType: secondType,
      title: title,
      resourceType: resourceType,
      tagUuids: tagUuids,
      howToCite: howToCite,
      description: description,
      licenseUrl: licenseUrl,
      serviceApi: serviceApi,
      licenseStatement: licenseStatement,
      isComputable: isComputable === null ? false : isComputable,
      isDownloadable: isDownloadable === null ? false : isDownloadable,
      isPublic: isPublic === null ? false : isPublic,
      authorUuids: authors,
      configuration: configuration,
      isAudit: status,
      dataSource: dataSource,
      sampleType: sampleType,
    };
    update(params);
  };

  // 选择一级标题
  const changeFirstType = (e) => {
    setFirstType(e.target.value);
    setSecondType("");
    setTypeTitle("");
    setResourceType("");
    setDataSource("");
    setSampleType("");
  };

  // 选择二级标题
  const changeSecondType = (e) => {
    setSecondType(e.target.value);
    setResourceType("");
    setDataSource("");
    setSampleType("");
  };

  return (
    <div className={classNames("container", styles.shareBox)}>
      {/*标题*/}
      <DetailTitle title="Title" isrequire={true} />
      <Input
        value={title}
        size="large"
        onChange={(e) => {
          setTitle(e.target.value);
        }}
        placeholder={intl.get("Share.Please input the title")}
        className={styles.mb50}
      />

      {/*类型*/}
      <DetailTitle title="Resource Type" isrequire={true} />
      <Radio.Group onChange={changeFirstType} value={firstType} disabled>
        {typeList.map((item) => (
          <Radio key={item.value} value={item.value}>
            {intl.get(`Header.${item.label}`)}
          </Radio>
        ))}
      </Radio.Group>
      <div className={styles.spaceBox}></div>
      <Radio.Group onChange={changeSecondType} value={secondType} disabled>
        {secondList.map((item) => (
          <Radio key={item.value} value={item.value}>
            {intl.get(`Header.${item.label}`)}
          </Radio>
        ))}
      </Radio.Group>

      {typeTitle && (
        <React.Fragment>
          <h4 className={styles.h4Box}>
            {intl.get(typeTitle)}
            <span>*</span>
          </h4>
          <Select
            size="large"
            style={{ width: "100%" }}
            value={resourceType}
            onChange={(e) => {
              setResourceType(e);
              setDataSource("");
              setSampleType("");
            }}
            disabled
            options={selectOption}
          />
        </React.Fragment>
      )}

      {/*武汉一号相关、数据来源、样本类型*/}
      {secondType === "OpenAITrainingData" && (
        <React.Fragment>
          <h4 className={styles.h4Box}>
            {intl.get("Data Source")}
            <span>*</span>
          </h4>
          <Select
            size="large"
            style={{ width: "100%" }}
            value={dataSource}
            onChange={(e) => {
              setDataSource(e);
            }}
            options={[
              {
                label: intl.get("Wuhan-1 Satellite Sample"),
                value: "Wuhan-1 Satellite Sample",
              },
              { label: intl.get("Other"), value: "Other" },
            ]}
          />
          {dataSource === "Wuhan-1 Satellite Sample" && (
            <React.Fragment>
              <h4 className={styles.h4Box}>
                {intl.get("Sample Type")}
                <span>*</span>
              </h4>
              <Select
                size="large"
                style={{ width: "100%" }}
                value={sampleType}
                onChange={(e) => {
                  setSampleType(e);
                }}
                options={[
                  {
                    label: intl.get("Scene Classification"),
                    value: "Scene Classification",
                  },
                  {
                    label: intl.get("Object Detection"),
                    value: "Object Detection",
                  },
                  {
                    label: intl.get("Semantic Segmentation"),
                    value: "Semantic Segmentation",
                  },
                  {
                    label: intl.get("Change Detection"),
                    value: "Change Detection",
                  },
                ]}
              />
            </React.Fragment>
          )}
        </React.Fragment>
      )}

      <div style={{ height: "50px" }}></div>
      {/*描述*/}
      <DetailTitle title="Description" isrequire={true} />
      <TextArea
        value={description}
        rows={6}
        className={styles.mb50}
        onChange={(e) => {
          setDescription(e.target.value);
        }}
      />

      {/*How to use*/}
      {(firstType === "OpenTools" || firstType === "OpenApps") && (
        <React.Fragment>
          <DetailTitle title="How to use" isrequire={true} />
          <Alert
            showIcon
            title="If you upload a readme.txt or readme.md file at the root level in your resource,it will be rendered automaticallly on the page.Markdown formatting is allowed in readme.md."
            type="info"
            className={styles.mb30}
          />
          <FileUpload
            suffix=".txt,.md"
            multiple={false}
            fileList={useFile_de}
            upList={updateHowToUseFileList}
            type="how to use"
            onUpload={handleHowToUseUpload}
            uploading={howToUseUploading}
          />
        </React.Fragment>
      )}

      {/*tag*/}
      <NewTag
        title="Tag"
        searchData={tagSearch}
        tagUuids={tagUuids}
        setTagUuids={setTagUuids}
        color="purple"
        quikTagList={quikTagList}
      />

      {/*地图*/}
      {firstType === "OpenData" && (
        <Coverage mapObj={mapObj} setMapObj={setMapObj} />
      )}

      {/*同意计算*/}
      {(firstType === "OpenData" || firstType === "OpenTools") && (
        <React.Fragment>
          <DetailTitle title="Computability" />
          <Checkbox
            className={styles.mb50}
            checked={isComputable}
            onChange={(e) => changeCheck(e, setIsComputable)}
          >
            {intl.get("Share.computeDes")}
          </Checkbox>
        </React.Fragment>
      )}

      {/*文件*/}
      {
        <React.Fragment>
          <DetailTitle
            isrequire={true}
            title={
              secondType === "OpenGeospatialData" ||
                secondType === "OpenAITrainingData"
                ? "Data"
                : "Content"
            }
          />
          <Alert
            showIcon
            title={intl.get("Share.disDes")}
            type="info"
            className={styles.mb30}
          />
          <UploadManage
            fileData={fileList_de}
            resourceUuid={resourceUuid}
            onFileListChange={setFileList_de}
          />
          {/* <FileUpload
            type="content"
            secondType={secondType}
            suffix={suffix}
            setFileList={setFileList}
            multiple={true}
            typeTitle={typeTitle}
            fileList={fileList_de}
            upList={setFileList_de}
            resourceType={resourceType}
          /> */}
        </React.Fragment>
      }
      {/* {suffix && (
        <React.Fragment>
          <DetailTitle
            isrequire={true}
            title={
              secondType === "OpenGeospatialData" ||
              secondType === "OpenAITrainingData"
                ? "Data"
                : "Content"
            }
          />
          <Alert
            showIcon
            message={intl.get("Share.disDes")}
            type="info"
            className={styles.mb30}
          />
          <UploadManage />
          <FileUpload
            type="content"
            secondType={secondType}
            suffix={suffix}
            setFileList={setFileList}
            multiple={true}
            typeTitle={typeTitle}
            fileList={fileList_de}
            upList={setFileList_de}
            resourceType={resourceType}
          />
        </React.Fragment>
      )} */}

      {/*单独针对Docker Image Tarball*/}
      {resourceType === "Docker Image Tarball" && isComputable && (
        <div className={styles.rasterBox}>
          <h4 className={styles.h4Box}>
            Config<span>*</span>
          </h4>
          <TextArea
            value={configuration}
            rows={4}
            onChange={(e) => {
              setConfiguration(e.target.value);
            }}
          />
        </div>
      )}

      {/*Server Api */}
      {isShow_api && (
        <React.Fragment>
          <DetailTitle title="Service API" />
          <Input
            value={serviceApi}
            size="large"
            onChange={(e) => {
              setServiceApi(e.target.value);
            }}
            placeholder="Please input the title"
            className={styles.mb50}
          />
        </React.Fragment>
      )}

      {/*作者*/}
      <NewTag
        title="Authors & Contributor"
        tagUuids={authors}
        searchData={authorsSearch}
        setTagUuids={setAuthors}
        color="gold"
      />

      {/*Related Resouces*/}
      <NewTag
        title="Related Resources"
        tagUuids={relatedResources}
        setTagUuids={setrelatedResources}
        color="geekblue"
      />

      {/*同意下载*/}
      {secondType !== "OpenDataServices" &&
        secondType !== "OpenProcessServices" &&
        secondType !== "OpenWebApps" && (
          <React.Fragment>
            <DetailTitle title="Downloadability" />
            <Checkbox
              className={styles.mb50}
              checked={isDownloadable}
              onChange={(e) => changeCheck(e, setIsDownloadable)}
            >
              {intl.get("Share.downloadDes")}
            </Checkbox>
          </React.Fragment>
        )}

      <DetailTitle title="Is public" />
      <Checkbox
        className={styles.mb50}
        checked={isPublic}
        onChange={(e) => changeCheck(e, setIsPublic)}
      >
        {intl.get("Share.Whether to expose the resource")}
      </Checkbox>

      {/*How to cite*/}
      <DetailTitle title="How to Cite" />
      <Alert
        showIcon
        title={intl.get("Share.citeDes")}
        type="info"
        className={styles.mb30}
      />
      <TextArea
        rows={3}
        value={howToCite}
        onChange={(e) => {
          setHowToCite(e.target.value);
        }}
        placeholder={intl.get("Share.citeInput")}
      />

      <Row gutter={40} className={styles.mb50}>
        <Col span={12}>
          <div className={styles.licenseBox}>
            <p>{intl.get("Share.Select a license")}</p>
            <Select
              value={licenseUrl ? licenseUrl : "other"}
              style={{ width: "100%" }}
              onChange={selectLicense}
              options={licenseList.map((item) => {
                return {
                  value: item.licenseUrl,
                  label: item.licenseName,
                };
              })}
            />
            {imgPath && <img src={process.env.REACT_APP_API_AFFIX + imgPath} />}
          </div>
        </Col>

        <Col span={12}>
          <div className={styles.licenseBox}>
            <p>{intl.get("Share.Statement")}</p>
            <TextArea
              disabled={dis}
              rows={2}
              value={licenseStatement}
              onChange={(e) => {
                setLicenseStatement(e.target.value);
              }}
            />
            <p>{intl.get("Share.Url")}</p>
            <Input
              disabled={dis}
              value={licenseUrl}
              onChange={(e) => {
                setLicenseUrl(e.target.value);
              }}
            />
          </div>
        </Col>
      </Row>

      <Spin
        spinning={loading}
        size="large"
        fullscreen={true}
        tip={intl.get("File is uploading, please wait patiently")}
      ></Spin>

      {/*提交*/}
      <div className={styles.btnBox}>
        <Button
          size="large"
          type="primary"
          disabled={howToUseUploading}
          onClick={() => submitForm(false)}
        >
          {intl.get("Share.Save as draft")}
        </Button>
        <Button
          size="large"
          type="primary"
          style={{ marginLeft: 20 }}
          disabled={howToUseUploading}
          onClick={() => submitForm(true)}
        >
          {intl.get("Share.Save and Submit")}
        </Button>
      </div>
    </div>
  );
};
export default Share;
